import React, { useEffect } from "react";
import { TriggeredHook } from "sonobello.utilities.react";

import { FlowStepProgress } from "../../types/FlowStepProgress";
import { GetCurrentStep, Step } from "../../types/Step";
import { Flow } from "../../Flows/types/IFlow";
import IPathObserver from "../../routing/types/IPathObserver";
import { IUsePostFlowStepProgressProps } from "../hooks/usePostFlowStepProgress";

export interface IReportStepProgressProps extends IPathObserver {
  /** The id of the contact associated with the current obx session. */
  contactId: string;
  /** The id of the flow for the current obx session. */
  flowId: string;
  /** The flow for the current obx session. */
  flow: Flow;
  /** A hook to report the current step progress. */
  usePostFlowStepProgress: TriggeredHook<null, FlowStepProgress, boolean, IUsePostFlowStepProgressProps>;
}

/** Tracks and reports the current session's step progress. */
const ReportStepProgress: React.FC<IReportStepProgressProps> = ({
  contactId,
  pathName,
  flowId,
  flow,
  usePostFlowStepProgress
}) => {
  const { execute } = usePostFlowStepProgress({ contactId, flowId });

  useEffect(() => {
    const currentStep = GetCurrentStep(pathName);
    if (currentStep) execute({ name: Step[currentStep], isEnded: flow.steps[currentStep]?.nextStep === null });
  }, [pathName]);

  return null;
};

export default ReportStepProgress;
